<template>
  <div class="lh-homes imgs" style="background-image:url(img/c1.png)">
    <div class="lh-logo1"><img src="img/logo-a.png" /><span>安全生产：合法权利与业务</span></div>
    <div class="lh-power clearfix">
    	<h3 class="title"><img src="img/c15.png" /></h3>
    	<ul class="lh-power-item l-grid-4 clearfix left">
    		<li v-for="(item,idx) in datas" :class="[item.hover,item.end]"><div :data-idx="idx" @click="item.hover?next($event):''">
    			<div class="icon1"><img src="img/c2.png" /></div>
    			<div class="icon2"><img :src="item.img" /></div>
    			<div class="jt"><img src="img/jt1.png" /></div>
    		</div></li>
    	</ul>
    	<div class="lh-power-r left" :class="imgOn">
    		<img :src="datasImg" />
    	</div>
    	<div class="lh-power-next" data-path="power1" @click="gotoNext($event)"><img src="img/next.png?a=1" /></div>
    </div>
    <Footer :footerData="footerData"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default{
	data(){
		return {
			footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:3,type:'culture'},
			datasIdx:0,
			imgOn:'',
			datasImg:'',
			datas:[
				{img:'img/c3.png?a=1',hover:'on',end:''},
				{img:'img/c4.png?a=1',hover:'',end:''},
				{img:'img/c5.png?a=1',hover:'',end:''},
				{img:'img/c6.png?a=1',hover:'',end:''},
				{img:'img/c7.png?a=1',hover:'',end:''},
				{img:'img/c8.png?a=1',hover:'',end:''},
				{img:'img/c9.png?a=1',hover:'',end:''},
				{img:'img/c10.png?a=1',hover:'',end:''},
				{img:'img/c11.png?a=1',hover:'',end:''},
				{img:'img/c12.png?a=1',hover:'',end:''},
				{img:'img/c13.png?a=1',hover:'',end:''},
			]
		}
	},
	created(e){
		var that=this;
	},
	mounted(e){
      var that=this;
    },
	components:{
		Footer
	},
	methods:{
		next(e){
			var that=this,tag = $(e.currentTarget),idx=$(e.currentTarget).data('idx');
			that.imgOn="";
			that.datasIdx+=1;
			that.datas[idx].end="end";
			that.datas[idx].hover="";
			setTimeout(function(){
				if(idx<10){
					that.datas[idx+1].hover="on";
				}else{
					$('.lh-power-next').addClass('on');
				}
				that.datasImg=that.datas[idx].img;
				that.imgOn="on";	
			},1000);
		},
		gotoNext(e){
			var that=this,tag = $(e.currentTarget),path=$(e.currentTarget).data('path');
			that.$router.replace({ path: path});
		}
	}
}
</script>
